import React, { memo } from 'react'
import { bool, oneOf, string } from 'prop-types'

import classNames from '../../helpers/class-names'

import './_style.scss'

const blk = 'asda-spinner'

const Spinner = ({
  className,
  category,
  size,
  isCenter,
  withOverlay,
  overlayClassName,
}) => {
  const spinnerClass = classNames({
    blk,
    className,
    mods: [
      category,
      size,
      isCenter && 'center',
    ],
  })

  if (withOverlay) {
    return (
      <div className={classNames({ blk, elt: 'overlay', className: overlayClassName })}>
        <div className={spinnerClass} />
      </div>
    )
  }

  return (
    <div className={spinnerClass} />
  )
}

Spinner.propTypes = {
  className: string,
  overlayClassName: string,
  category: oneOf(['primary', 'secondary', 'primary-light', 'secondary-light']),
  size: oneOf(['small', 'medium', 'large']),
  isCenter: bool,
  withOverlay: bool,
}

Spinner.defaultProps = {
  className: '',
  overlayClassName: '',
  category: 'primary',
  size: 'medium',
  isCenter: true,
  withOverlay: false,
}

export default memo(Spinner)



// WEBPACK FOOTER //
// ./common/components/spinner/index.js